export default __webpack_public_path__ + "static/carousel_image_2_cannes-eee9738f1411af8271905d804bb31dc1.jpg";